export default __webpack_public_path__ + "static/media/vehiclesModuleImage.fc04335f.svg";